exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-event[data-v-558f924d]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border-radius:2px;background-color:#009688;color:#fff;width:100%;font-size:12px;padding:5px;cursor:pointer;margin-bottom:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-558f924d","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/mensagens/Calendario.vue
// module id = 913
// module chunks = 0